{
    "coordinates": [
        -32.677829209565346,
        151.7892546042954
    ],
    "tooltip": "Seaham",
    "title": "Seaham Quarry",
    "country": "Australia",
    "period": "Carboniferous",
    "alt": "TODO"
}
